<template>
    <div class="hhjcTable">
        <ivuTable :row-class-name="rowClassName" :columns="columns" :data="data" :show-header="false"></ivuTable>
    </div>
</template>

<script>
    import { Table as ivuTable } from 'iview';
    export default {
        props: [ 'row', 'concede', 'type', 'isLottery' ],
        data () {
            return {
                columns: [
                    {
                        title: 'Name',
                        align: 'center',
                        // eslint-disable-next-line complexity
                        render: ( h, params ) => {
                            let type = params.row.odds_type;
                            let str = '';
                            let tdHeight = 46;//
                            if ( this.isLottery ) {
                                let winLostDraw = [ 1, 2 ];
                                if ( winLostDraw.includes( type ) ) {
                                    if ( params.row.result_str == 'win' ) {
                                        str = '胜';
                                    } else if ( params.row.result_str == 'lose' ) {
                                        str = '负';
                                    } else if ( params.row.result_str == 'draw' ) {
                                        str = '平';
                                    }
                                } else if ( type == 3 && params.row.result_str != '' ) {
                                    str = params.row.result_str + '球';
                                } else if ( type == 4 ) {
                                    str = params.row.result_str;
                                } else if ( type == 5 && params.row.result_str != '' ) {
                                    str = params.row.result_str.slice( 0, 1 ) + ' / ' + params.row.result_str.slice( 1 );
                                }
                            }
                            if ( type == 3 || type == 4 || type == 5 ) {
                                let rowContent = 3;
                                let listLength = JSON.parse( params.row.content ).length;
                                if ( listLength > rowContent ) {
                                    let row = parseInt( listLength % rowContent === 0 ? listLength / rowContent - 1 : listLength / rowContent );
                                    tdHeight = tdHeight + row * 24 + row * 8 + row * rowContent;
                                }
                            }
                            if ( this.row.match_info.status >= 100 ) {
                                str = '延期';
                            }
                            return h( 'div', {
                                attrs: {
                                    class: 'verticalCenter',
                                },
                                style: {
                                    color: 'red',
                                    height: `${tdHeight}px`,
                                },
                            }, str );
                        },
                    },
                ],
                data: null,
            };
        },
        created () {
            let arr = [];
            let keyArr = [ 'odds_base', 'odds_goals', 'odds_half_whole', 'odds_handicap', 'odds_point' ];
            for ( let key in this.row ) {
                if ( keyArr.includes( key ) ) {
                    arr.push( this.row[ key ] );
                }
            }
            this.data = arr;
        },
        methods: {
            rowClassName ( row, index ) {
                if ( index === this.data.length - 1 ) {
                    return 'last-child-row';
                }
                return '';
            },
        },
        components: {
            ivuTable,
        },
    };
</script>